import { Component, Inject, ViewChild } from '@angular/core';
import { ServerAPI } from '../../serverapi';
import { JSBridgeService } from '../jsbridge.service';
import { HistoryEntry } from '@server/src/types';
import { XMLCompareComponent } from '../../debug/xmlcompare/xmlcompare.component';
import { DialogService } from '@progress/kendo-angular-dialog';
import { TitleDialogComponent } from '../../afdeling/title-dialog/title-dialog.component';
import { KopHistoryListComponent } from '../kop-history-list/kop-history-list.component';

@Component({
  selector: 'kop-history',
  templateUrl: './kop-history.component.html',
  styleUrls: ['./kop-history.component.scss'],
  providers: [
    {
      provide: 'i18n-label',
      useValue: 'KopHistoryComponent'
    }
  ]
})
export class KopHistoryComponent {

  constructor(@Inject('ServerApi') public electronApi: ServerAPI, public jsBridgeService: JSBridgeService, private dialogService: DialogService) {
  }

  public isEditing = false;
  public left: HistoryEntry | undefined;
  public right: HistoryEntry | undefined;
  @ViewChild(XMLCompareComponent, { static: true }) xmlCompare: XMLCompareComponent | undefined = undefined;

  public async open() {
    this.left = undefined;
    this.right = undefined;
    this.isEditing = true;
  }
  public restoreHistory(id: string | undefined) {
    if (id == undefined) {
      return;
    }
    let klantNo = this.jsBridgeService.getKlantNo();
    this.jsBridgeService.initKlantNo(klantNo, id);
    this.isEditing = false;
  }

  public compareHistories() {
    if (this.left == undefined || this.right == undefined || this.xmlCompare == undefined) {
      return;
    }
    this.xmlCompare.open(this.left, this.right);
    // this.jsBridgeService.compareHistories(this.left, this.right);

  }

  @ViewChild(KopHistoryListComponent) leftList: KopHistoryListComponent | undefined = undefined;
  

  public editComment(history: HistoryEntry | undefined) {
    if (history == undefined) {
      return;
    }

    const dialogRef = this.dialogService.open({
      width: 400,
      content: TitleDialogComponent,
    });

    const titleDlg = dialogRef.content.instance as TitleDialogComponent;
    titleDlg.maxLength = 1000;
    titleDlg.dialogNameKey.set('Comments');
    titleDlg.title = history.comments != undefined ? history.comments : "";
    dialogRef.result.subscribe(async (r: any) => {
      if (r.text == "Submit" && history.id != undefined) {
        let comments = r.naam;
        await this.electronApi.editHistory(this.jsBridgeService.getKlantNo(), history.id, comments);
        if (this.leftList != undefined) {
          this.leftList.refresh();
        }
      }
    });
  }

}
